import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { AppComponent } from '../app.component';
import { PermissionsService } from '../services/permissions.service';

@Component({
  selector: 'app-blocked-rooms-config',
  templateUrl: './blocked-rooms-config.component.html',
  styleUrls: ['./blocked-rooms-config.component.scss']
})
export class BlockedRoomsConfigComponent implements OnInit {

  public allDharmshalas: any[] = [];
  public allRooms: any[] = [];
  public filteredRooms: any[] = [];
  public selectedDharmshalaId: string = '';
  public editingRoom: any = null;

  constructor(
    private apiService: ApiService,
    private appComponent: AppComponent,
    public permissionsService: PermissionsService
  ) { }

  ngOnInit() {
    this.getAllDharmshalas();
    this.getAllRooms();
  }

  getAllDharmshalas() {
    this.apiService.getDataFromServer('/dharmashalas').subscribe(
      (res: any) => {
        this.allDharmshalas = res.data || [];
      },
      err => {
        console.log(err);
      }
    );
  }

  getAllRooms() {
    this.appComponent.showLoader();
    this.apiService.getDataFromServer('/dharmshala_rooms').subscribe(
      (res: any) => {
        this.appComponent.hideLoader();
        this.allRooms = res.data || [];
        this.filterRooms();
      },
      err => {
        this.appComponent.hideLoader();
        console.log(err);
      }
    );
  }

  filterRooms() {
    if (this.selectedDharmshalaId) {
      this.filteredRooms = this.allRooms.filter(room => room.dharmashala_id == this.selectedDharmshalaId);
    } else {
      this.filteredRooms = this.allRooms.slice();
    }
  }

  onDharmshalaChange() {
    this.filterRooms();
  }

  editRoom(room: any) {
    this.editingRoom = {
      id: room.id,
      blocked_rooms: room.blocked_rooms || 0,
      block_release_days: room.block_release_days || 1,
      no_of_rooms: room.no_of_rooms
    };
  }

  cancelEdit() {
    this.editingRoom = null;
  }

  updateRoom() {
    if (!this.editingRoom) return;

    if (this.editingRoom.blocked_rooms < 0) {
      this.appComponent.showMessageAlert('Blocked rooms cannot be negative', 'error');
      return;
    }

    if (this.editingRoom.blocked_rooms > this.editingRoom.no_of_rooms) {
      this.appComponent.showMessageAlert('Blocked rooms cannot exceed total rooms', 'error');
      return;
    }

    if (this.editingRoom.block_release_days < 0) {
      this.appComponent.showMessageAlert('Block release days cannot be negative', 'error');
      return;
    }

    this.appComponent.showLoader();
    const payload = {
      blocked_rooms: this.editingRoom.blocked_rooms,
      block_release_days: this.editingRoom.block_release_days
    };

    this.apiService.putDataToServer(`/dharmshala_rooms/${this.editingRoom.id}`, payload).subscribe(
      (res: any) => {
        this.appComponent.hideLoader();
        this.appComponent.showMessageAlert('Room configuration updated successfully', 'success');
        this.editingRoom = null;
        this.getAllRooms();
      },
      err => {
        this.appComponent.hideLoader();
        const errorMessage = (err.error && err.error.error && err.error.error[0] && err.error.error[0].message) || 'Failed to update room configuration';
        this.appComponent.showMessageAlert(errorMessage, 'error');
      }
    );
  }

}
